import Fmn from "../../assets/forget-me-not.jpg";
import Passg from "../../assets/passg.jpg";
import Lovetastrophe from "../../assets/lovetastrophe.jpg";

export const projectsData = [
  {
    id: 1,
    image: Fmn,
    title: "Forget-Me-Not",
    url: "https://mohameddhia-hasni.github.io/Forget-Me-Not/",
  },
  {
    id: 2,
    image: Passg,
    title: "Password Generator",
    url: "https://mohameddhia-hasni.github.io/PasswordGenerator/",
  },
  {
    id: 3,
    image: Lovetastrophe,
    title: "Lovetastrophe",
    url: "https://mohameddhia-hasni.github.io/Lovetastrophe/",
  },
];
